export const k = {
    header: "domains.application.components.main-layout.components.error-handler-i18n.header"
};
export const translations = {
    da: { header: "Fejl" },
    en: { header: "Error" }
};
